import {Map} from "immutable";
import * as React from "react";
import {connect, useDispatch} from "react-redux";
import {
    hasHoldings,
    investmentsEnabled,
    isEditingPlanPortfolio,
    portfolioProductSummariesSelector,
    productUniverseSummariesSelector,
    userType,
} from "../../../mainReducerMapSelectors";
import {getBrowserLocationPath} from "../../api/BrowserWrapper";
import {ProductSummary} from "../../model/product/ProductSummary";
import {ResearchSearchItem} from "../../model/Search.model";
import {getSearchItemsFromProducts} from "../../utils/researchUtil";
import {hasConsultantLevelAccess} from "../../utils/sessionUtil";
import {
    allResearchItems,
    investmentsItem,
    IResearchNavigationMenuItems,
    researchItem,
    ResearchMenuItems,
} from "../base/NavItems";
import SubNav from "../base/SubNav.component";
import {getSuccessData} from "../common/commonStates";
import {UserTypeEnum} from "../../model/UserInfo.model";
import {IApplicationRootState} from "../../../applicationState";
import {showInvestments} from "../../utils/navigationUtils";
import {useEffect} from "react";
import {getAllProducts, getPortfolioProductSummaries} from "../product/AllProductsActions";
import {useNavigate} from "react-router-dom";
import {multipleApiRequesterWrapper} from "../common/MultipleApiRequesterWrapper";
import {navigateTo} from "../../../navigateTo";
import {AnyThunkDispatch} from "../../../commonTypes";

interface IResearchNavPropsFromState {
    editingPlanPortfolio: boolean;
    hasHoldings: boolean;
    productUniverseSummaries: Map<number, ProductSummary> | null;
    portfolioProductSummaries: Map<number, ProductSummary> | null;
    userType: UserTypeEnum;
    investmentsEnabled: boolean;
}

export type ResearchNavProps = IResearchNavPropsFromState;

export const researchDescription = "Explore Aon's comprehensive views on investment managers and strategies. " +
    "Research and gain insights into the various investment opportunities available.";

export const ResearchNavComponent: React.FunctionComponent<ResearchNavProps> = (props) => {
    const menuItems = getNavigationMenuItems();
    const dispatch: AnyThunkDispatch = useDispatch();
    const navigate = useNavigate();

    function getResearchMenuItemFromUrl() {
        const maybeMenuItem =
            allResearchItems.find((item) => getBrowserLocationPath().includes(item.targetUrl));
        return maybeMenuItem ? maybeMenuItem.id : researchItem.id;
    }

    function getNavigationMenuItems(): IResearchNavigationMenuItems[] {
        const maybeInvestmentsItem = showInvestments(props.hasHoldings, props.userType, props.investmentsEnabled)
            ? investmentsItem
            : undefined;

        return [maybeInvestmentsItem, researchItem]
            .filter((item) => !!item) as IResearchNavigationMenuItems[];
    }

    function isSearchEnabled() {
        const isResearchPage = getBrowserLocationPath().includes("/research");
        return isResearchPage
            ? props.editingPlanPortfolio && getResearchMenuItemFromUrl() === ResearchMenuItems.RESEARCH_ID.toString()
            : getResearchMenuItemFromUrl() === ResearchMenuItems.RESEARCH_ID.toString();
    }

    function onItemSelected(selectedMenuItem: string) {
        navigateTo(
            menuItems.find((item) => item.id === selectedMenuItem)!.targetUrl,
            navigate
        );
    }

    function getSearchItems(): ResearchSearchItem[] {
        const universeSummaries = props.productUniverseSummaries?.valueSeq().toArray();
        const portfolioSummaries = props.portfolioProductSummaries?.valueSeq().toArray();
        const productSummaries = (hasConsultantLevelAccess() && props.editingPlanPortfolio)
            ? (universeSummaries && universeSummaries.length > 0 ? universeSummaries : portfolioSummaries)
            : portfolioSummaries;

        return productSummaries ? getSearchItemsFromProducts(productSummaries) : [];
    }

    useEffect(() => {
        if (hasConsultantLevelAccess() && props.editingPlanPortfolio && !props.productUniverseSummaries) {
            dispatch(getAllProducts);
        } else if (!props.portfolioProductSummaries) {
            dispatch(getPortfolioProductSummaries);
        }
    }, [props.editingPlanPortfolio]);

    return <div>
        <SubNav
            menuItems={menuItems}
            searchEnabled={isSearchEnabled()}
            onItemSelected={onItemSelected}
            selectedMenuItem={getResearchMenuItemFromUrl()}
            searchItems={getSearchItems()}
        />
    </div>;
};

export const mapStateToProps = (state: IApplicationRootState): IResearchNavPropsFromState => {
    return {
        editingPlanPortfolio: isEditingPlanPortfolio(state),
        hasHoldings: hasHoldings(state),
        productUniverseSummaries: getSuccessData(productUniverseSummariesSelector(state))!,
        portfolioProductSummaries: getSuccessData(portfolioProductSummariesSelector(state))!,
        userType: userType(state),
        investmentsEnabled: investmentsEnabled(state),
    };
};

// export default withRouter(connect<IResearchNavPropsFromState>(mapStateToProps)(ResearchNavComponent));
// export default connect<IResearchNavPropsFromState>(mapStateToProps)(ResearchNavComponent);

export default multipleApiRequesterWrapper(connect<IResearchNavPropsFromState>(mapStateToProps)(ResearchNavComponent), []);
